import React from "react";
import PropTypes from "prop-types";
import { emptyString } from "../../../../constants";

const PasswordValidationMessage = ({ isValid, message }) => (
  <li className={`${isValid ? "text-success bold-4" : emptyString}`}>
    <small>{message}</small>
  </li>
);

PasswordValidationMessage.propTypes = {
  isValid: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default PasswordValidationMessage;
